import React from "react";
import MessageNode from "../Whatsapp/MessageNode";
import { getMpmProductCount, getMpmThumbnailImage, getSpmProductName } from "../Whatsapp/mpmPreviewUtils";
import { authPreviewProps } from "../Whatsapp/authTemplateUtils";

// WhatsApp message preview of a template (the broadcast form's preview modal, the Campaigns (Beta) single page
// and its fallback card). templatePreviewData = the template's template_preview_json.
const TemplateMessagePreview = ({ templatePreviewData, carouselMediaFiles = {} }) => (
  <>
    {templatePreviewData?.marketingOption === "carousel" ? (
      <MessageNode
        templateName={templatePreviewData.templateName}
        language={templatePreviewData.language}
        headerType="none"
        headerText=""
        headerFile={null}
        body=""
        sampleBodyFields={[]}
        footer=""
        mode="view"
        allButtons={[]}
        marketingOption="carousel"
        carouselCards={templatePreviewData.carouselCards}
        carouselMainBody={templatePreviewData.carouselMainBody}
        carouselMainBodySampleFields={
          templatePreviewData.carouselMainBodySampleFields || []
        }
        {...Object.keys(templatePreviewData)
          .filter((key) => key.startsWith("cardFile_"))
          .reduce((acc, key) => {
            acc[key] = templatePreviewData[key];
            return acc;
          }, {})}
        {...Object.keys(carouselMediaFiles).reduce((acc, index) => {
          acc[`cardFile_${index}`] = carouselMediaFiles[index];
          return acc;
        }, {})}
        key={`carousel-preview-${JSON.stringify(Object.keys(carouselMediaFiles))}`}
      />
    ) : (
      <MessageNode
        templateName={templatePreviewData?.template_name || ""}
        marketingOption={templatePreviewData?.marketingOption || null}
        language={templatePreviewData?.language || "english"}
        headerType={templatePreviewData?.headerType || "none"}
        headerText={templatePreviewData?.headerText || ""}
        headerFile={templatePreviewData?.headerFile || null}
        body={templatePreviewData?.body || "No template selected"}
        sampleBodyFields={templatePreviewData?.sampleBodyFields || []}
        sampleHeaderFields={templatePreviewData?.sampleHeaderFields || []}
        footer={templatePreviewData?.footer || ""}
        allButtons={templatePreviewData?.allButtons || []}
        mode="view"
        location={templatePreviewData?.location || null}
        showSampleValues
        productCount={getMpmProductCount(templatePreviewData?.mpmSections)}
        thumbnailImage={getMpmThumbnailImage(templatePreviewData?.mpmThumbnail || templatePreviewData?.spmProduct)}
        productName={getSpmProductName(templatePreviewData?.spmProduct)}
        {...authPreviewProps(templatePreviewData)}
      />
    )}
  </>
);

export default TemplateMessagePreview;
